import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ExecutorModel} from '../models/executor.model';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseExecuteViewService {

  constructor(
    protected http: HttpClient
  ) {
  }

  getExecute(executeId: number): Observable<ExecutorModel> {
    const expand = [
      'birth_date_timestamp',
      'projectName',
      'executor_photo',
      'employees',
      'employees.user',
      'employees.extendedRegistrationForm',
      'employees.confirmation_date_timestamp',
    ].join(',');
    const httpParams = (new HttpParams()).append('expand', expand);
    return this.http.get<ExecutorModel>(
      environment.apiBasepoint + 'executor/' + executeId,
      {
        params: httpParams,
        observe: 'body'
      }
    );
  }
}
